import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from "clsx";
import { TypographyRoot } from "./typography.styles.js";
import { useUtilityClasses } from "./typography.classes.js";
import { useThemeProps } from "@mui/material/styles";
import { unstable_extendSxProp } from "@mui/system";
const defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "p",
  subtitle2: "p",
  subtitle3: "p",
  body1: "p",
  body2: "p",
  body3: "span",
  button1: "span",
  button2: "span",
  button3: "span",
  caption: "p",
  inherit: "p"
};
const Typography = forwardRef(function Typography2(inProps, ref) {
  const themeProps = useThemeProps({ props: inProps, name: "TrueTypography" });
  const props = unstable_extendSxProp({ ...themeProps });
  const {
    component,
    paragraph = false,
    variant = "body1",
    noGutter = true,
    gutterBottom = false,
    className,
    eventId,
    strikethrough = false,
    highlight = false,
    noWrap = false,
    ...isProps
  } = props;
  const ownerState = {
    ...isProps,
    paragraph,
    noGutter,
    variant,
    gutterBottom,
    strikethrough,
    highlight,
    noWrap,
    color: isProps?.sx?.color
  };
  const Component = component || (paragraph ? "p" : defaultVariantMapping[variant]) || "span";
  const classes = useUtilityClasses(ownerState);
  return /* @__PURE__ */ jsx(
    TypographyRoot,
    {
      as: Component,
      ref,
      ownerState,
      className: clsx(classes.root, className),
      "data-eventid": eventId,
      ...isProps
    }
  );
});
export {
  Typography
};
//# sourceMappingURL=typography.component.js.map
